import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const InicioPage = lazy(() => import('../pages/inicio/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/es',
    element: <InicioPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
